/** Element id and URL hash of the Recording card on Settings › Telephony. */
export const RECORDING_SETTINGS_SECTION_ID = 'recording';
